import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { MasterDataService } from 'src/app/common/master-data.service';
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { DateFormat } from 'src/app/core/constants/app.constant';
import { BaseService } from 'src/app/core/services/base.service';
import { IResponse } from 'src/app/shared/models/app';

@Injectable({
  providedIn: 'root'
})
export class ReceiveShipmentService extends BaseService {

  supplies: any;
  sealedSources: any;
  uoms: any;
  activeUsers: any;
  manufacturers: any;
  isotopes: any;
  surveyInstruments: any;
  wipeInstruments: any;
  vendors: any;
  products: any;
  filteredProducts: any;
  $orders = new BehaviorSubject<any>([]);
  $receiveDateTime = new BehaviorSubject<any>(null);
  $deliveryDateTime = new BehaviorSubject<any>(null);
  $showUnsaveMessage = new BehaviorSubject<any>(null);

  constructor(protected http: HttpClient, private cacheService: CacheResolverService, private masterDataService: MasterDataService,
    private datePipe: DatePipe) {
    super(http);
    this.init();
  }

  init() {

  }

  getSurveyInstruments(date, searchAcrossDepts,usge) {
    return super.fetch(this.apiConfig.hp + '/api/instrument/search', {
      params: {
        date: moment(date).format(),
        searchAcrossDepts: searchAcrossDepts, usage: usge
      }
    }).pipe(
      map((response: IResponse) => {
        let res=null;
        if(!response.hasError){
           res = this.filterInstruments(response.data,{"mR/hr":true});
        }
        return res;
      })
    );
  }


  getWipeInstruments(date, searchAcrossDepts,usge) {
    return super.fetch(this.apiConfig.hp + '/api/instrument/search', {
      params: {
        date: moment(date).format(),
        searchAcrossDepts: searchAcrossDepts,
        usage: usge
      }
    }).pipe(
      map((response: IResponse) => {
        let res=null;
        if(!response.hasError){
           res = this.filterInstruments(response.data,{"CPM":true,"DPM":true});
        }
        return res;
      })
    );
  }
  filterInstruments(instruments,allowedUomsAsMap) {
    let retVal = [];
    instruments.forEach((instrument)=>{
      if (instrument.usageUom && allowedUomsAsMap[instrument.usageUom.name]) {
        retVal.push(instrument);
      }
    });
    return retVal;
  }

  getSearchData(data) {

let paramObj=data.shippingNum?{
  params: { type: data.type, vendor: data.vendor, id: data.id,shippingNum:data.shippingNum }
}:{
  params: { type: data.type, vendor: data.vendor, id: data.id, }
}
    const request = {};
    return super.fetch(this.apiConfig.inventory + '/api/receiveshipment/search/details',paramObj).pipe(
      map((response: IResponse) => {
        let res=null;
        if(!response.hasError){
           res = this.transformForLoad(response.data);
        }
        return res;
      })

    )
  }

  transformForLoad(data) {
    var orders = [];
    if (data.orders) {
      data.orders.forEach(function (order) {
        orders.push(order)
      });
    }
    var retVal = data;
    retVal.orders = orders;
    if (retVal.shipment && retVal.shipmentNote) {
      retVal.shipment.note = retVal.shipmentNote;
      retVal.shipment.note.currentText = retVal.shipment.note.text;
    }
    if (retVal.survey && retVal.surveyNote) {
      retVal.survey.note = retVal.surveyNote;
      retVal.survey.note.currentText = retVal.survey.note.text;
    }
    if (retVal.wipe && retVal.wipeNote) {
      retVal.wipe.note = retVal.wipeNote;
      retVal.wipe.note.currentText = retVal.wipe.note.text;
    }
    if (retVal.wipe) {
      retVal.wipe.contentsCpm = (retVal.wipe.contentsCpm) ? (retVal.wipe.contentsCpm) : -1;
      retVal.wipe.contentsDpm = (retVal.wipe.contentsDpm) ? (retVal.wipe.contentsDpm) : -1;
      retVal.wipe.surfaceCpm = (retVal.wipe.surfaceCpm) ? (retVal.wipe.surfaceCpm) : -1;
      retVal.wipe.surfaceDpm = (retVal.wipe.surfaceDpm) ? (retVal.wipe.surfaceDpm) : -1;
    }
    return retVal;
  }


  getBackgroundValue(taskType: String, uomNum: any, date: any) {
    date =moment(date).format('MM/DD/YYYY');
    return super.fetch(this.apiConfig.hp + '/api/background/search', { params: { uomNum: uomNum, taskType: taskType, date: date } })
  }


  save(data,shipmentId, overideDetails) {
    let url = this.apiConfig.inventory;
    let myData: any = this.transformForSave(data,shipmentId,overideDetails);
    if (shipmentId) {
    return  super.put(url + '/api/receiveshipment/' + shipmentId, myData);
    }else{
      return super.post(url + '/api/receiveshipment', myData);
    }

  }

  transformForSave(data: any,shipmentId,overideDetails) {
    const mob=this.cacheService.get(CacheConstant.LocalStorage.Mobile)
    var retVal: any = {
      shipment: this.transformShipment(data.shipment,shipmentId,overideDetails),
      survey:data.survey? this.transformSurvey(data.survey,overideDetails):{},
      wipe:data.wipe? this.transformWipe(data.wipe,overideDetails):{},
      orders:data.orders?data.orders:null, //data.orders,
      shipmentNote: { text: data.shipment.shipmentNote.text },
      mobileNum:mob?mob.id:null
    };
    if (data.survey) {
      retVal.surveyNote = { id: data.survey.surveyNote.id, text: data.survey.surveyNote.text };
    }
    if (data.wipe) {
      retVal.wipeNote = { id: data.wipe.wipeNote.id, text: data.wipe.wipeNote.text };
    }
    retVal.shipment.transportationIndex = parseFloat(retVal.shipment.transportationIndex);
    retVal.shipment.boxId = parseInt(retVal.shipment.boxId);
    if (retVal.shipment.vendor && retVal.shipment.vendor.vendorName) {
      retVal.shipment.vendor = retVal.shipment.vendor.vendorName;
    }
    if (retVal.shipment.radioActive) {
      ['surface', 'background', 'oneMeter'].forEach((value) => {
        retVal.survey[value] = parseFloat(retVal.survey[value]);
      });
      ['background', 'surfaceCpm', 'contentsCpm', 'surfaceDpm', 'contentsDpm', 'countSeconds',
        'area', 'actionLevel', 'efficiency'].forEach((value) => {
          retVal.wipe[value] = parseFloat(retVal.wipe[value]);
        });
    }
    if (retVal.orders) {
      retVal.orders.forEach((order) => {
        if (order.product) {
          if (order.actUomId == null || order.actUomId < 0) {
            order.actUomId = order.product.actUom.id;
          }
          order.productType = order.product.productType;
        }
      });
    }
    return retVal;
  }


  // transformForSave(data: any) {
  //   var retVal: any = {
  //     shipment: this.transformShipment(data.shipment),
  //     survey: this.transformSurvey(data.survey),
  //     wipe: this.transformWipe(data.wipe),
  //     orders: data.orders,
  //     shipmentNote: { text: data.note.shipment.text },
  //     mobileNum: this.cacheService.get('mobileNum')
  //   };
  //   if (data.survey) {
  //     retVal.surveyNote = { id: data.note.survey.id, text: data.note.survey.text };
  //   }
  //   if (data.wipe) {
  //     retVal.wipeNote = { id: data.note.wipe.id, text: data.note.wipe.text };
  //   }
  //   retVal.shipment.transportationIndex = parseFloat(retVal.shipment.transportationIndex);
  //   retVal.shipment.boxId = parseInt(retVal.shipment.boxId);
  //   if (retVal.shipment.vendor && retVal.shipment.vendor.vendorName) {
  //     retVal.shipment.vendor = retVal.shipment.vendor.vendorName;
  //   }
  //   if (retVal.shipment.radioActive) {
  //     ['surface', 'background', 'oneMeter'].forEach(function (value) {
  //       retVal.survey[value] = parseFloat(retVal.survey[value]);
  //     });
  //     ['background', 'surfaceCpm', 'contentsCpm', 'surfaceDpm', 'contentsDpm', 'countSeconds',
  //       'area', 'actionLevel', 'efficiency'].forEach(function (value) {
  //         retVal.wipe[value] = parseFloat(retVal.wipe[value]);
  //       });
  //   }
  //   if (retVal.orders) {
  //     retVal.orders.forEach(function (order) {
  //       if (order.product) {
  //         if (order.actUomId == null || order.actUomId < 0) {
  //           order.actUomId = order.product.actUom.id;
  //         }
  //         order.productType = order.product.productType;
  //       }
  //     });
  //   }
  //   return retVal;
  // }

  transformShipment(shipment,shipmentId,overideDetails) {
    shipment = shipment.df.value;
    let retVal:any={};
     retVal = {
      boxId: shipment.boxNum,
      shippingId: shipment.shipmentNum,
      receiveDate:moment(
        this.datePipe.transform(shipment.receiveDate, DateFormat.DatePipeFormat) + ' ' + shipment.receiveTime
      ).format(), //shipment.receiveDate, //date + time fix
      deliveryDate:moment(
        this.datePipe.transform(shipment.deliveryDate, DateFormat.DatePipeFormat) + ' ' + shipment.deliveryTime
      ).format(),
      performer: shipment.performedBy && shipment.performedBy.fullName?shipment.performedBy.fullName:shipment.performedBy,
      vendor: shipment.vendor,
      packageBar: shipment.packageBar? shipment.packageBar.name:null,
      transportationIndex: shipment.transportationIndex,
      radioActive: shipment.radioActive,
      createWasteBin: shipment.createWasteBin,
      packageCondition: shipment.pkgCondition,
      overrideBy: overideDetails ? overideDetails.overideShip : ' ', //missing
      overrideComments: overideDetails ? overideDetails.transportNotes : ' ' //missing
    }
    if(shipmentId){
      retVal.id=shipmentId;
    }
    return retVal;
  }

  transformSurvey (survey,overideDetails) {
    survey = survey.sf.value;
    var retVal = {
      background: survey.background,
      oneMeter: survey.oneMeter,
      surface: survey.surface,
      instrument: survey.selectedInstrument ? { id: survey.selectedInstrument.id, usageUom: { id: survey.selectedInstrument.usageUom.id } } : null,
      overrideBy: overideDetails ? overideDetails.overideSurvey : ' ', //missing
      overrideComments: overideDetails ? overideDetails.surveyNotes : ' ' //missing
    }
    return retVal;
  }

  transformWipe  (wipe,overideDetails) {
    wipe = wipe.wf.value;
    var retVal = {
      efficiency: wipe.insEfficiency,
      actionLevel: wipe.actLevel,
      area: wipe.wipeArea,
      background: wipe.background,
      countSeconds: wipe.countSeconds,
      instrument: wipe.selectedInstrument ? { id: wipe.selectedInstrument.id, usageUom: { id: wipe.selectedInstrument.usageUom.id } } : null,
      surfaceCpm: wipe.surfaceCPM,
      surfaceDpm: wipe.surfaceDPM,
      contentsCpm: wipe.contentCPM,
      contentsDpm: wipe.contentDPM,
      overrideBy: overideDetails ? overideDetails.overideWipe : ' ', //missing
      changeInstrumentEfficiency: wipe.changeInstrumentEfficiency ? true : false, //missing
      overrideComments: overideDetails ? overideDetails.wipeNotes : ' ' //missing
    }
    return retVal;
  }

  transformOrders(orders) {
    orders.forEach(order => {
      if(order?.expirationDate && order.expirationTime){
        order.expirationDate = moment(this.datePipe.transform(order.expirationDate, 'MM/dd/yyyy') + ' ' + order.expirationTime).format();
      }

      if (order?.calibrationDate && order.calibrationTime) {
        order.calibrationDate = moment(this.datePipe.transform(order.calibrationDate, 'MM/dd/yyyy') + ' ' + order.calibrationTime).format();
      }
    });
    return orders;
  }

  getBarcodeData(orderNum) {
    let url = this.apiConfig.order;
    return super.fetch(url + '/api/customerorder/' + orderNum, {});
  }

  saveSealedSource(data){
    let url = this.apiConfig.inventory;
    let sealedSourceData: any = this.transformForSaveSealedSource(data);
    return super.post(url +'/api/receiveshipment/sealedsource',sealedSourceData);
  }

  transformForSaveSealedSource(data){
      let orderValue: any = {
        orders:data.orders ? data.orders:null
      };
      if (orderValue.orders) {
        orderValue.orders.forEach((order) => {
          if (order.product) {
            if (order.actUomId == null || order.actUomId < 0) {
              order.actUomId = order.product.actUom.id;
            }
            order.productType = order.product.productType;
          }
        });
      }
      return orderValue;
  }

  truncateText(value: string, limit: number): string {
    if (!value) return '';
     return value.length > limit ? value.substring(0, limit) + '...' : value;
   }


}
